import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import gamblerGame from "./gamblerGame";
import { GamblerDataSaveType } from "./gamblerGameConst";
import gamblerGameObj from "./gamblerGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class gamblerCut extends cc.Component {

    canCut:boolean = true;

    cutNode:cc.Node = null;

    @property({type:cc.Node,displayName:"次数不足节点"})
    notCountNode:cc.Node = null;

    @property({type:cc.Node,displayName:"重置按钮"})
    btnReset:cc.Node = null;

    @property({type:cc.Node,displayName:"切一刀按钮"})
    startCutBtn:cc.Node = null;

    @property(cc.Label)
    labelCount: cc.Label = null;

    @property({ type: sp.Skeleton, displayName:'' })
	nodeToolsSpine: sp.Skeleton = null;

    private cutCountKey:string = GamblerDataSaveType.GAMBLER_CUT_KEY;

    private cutCountDayKey:string = GamblerDataSaveType.GAMBLER_CUTCOUNT_DAY_KEY;

    gameScript:gamblerGame = null;

    buyScript:gamblerGameObj = null;

    onLoad(){
        this.nodeToolsSpine.node.active = false;
        this.nodeToolsSpine.node.zIndex = 2;
        this.cutNode.setParent(this.node);
        this.cutNode.setPosition(cc.v2(0,-160 - (this.cutNode.height / 2)));
        this.buyScript.canClick = false;
        this.buyScript.updatePrice();
        // console.log(this.cutNode,"?????????????",this.cutNode.isValid,this.cutNode.parent.name,this.cutNode.getPosition(),this.cutNode.height / 2)
    }

    bindNode(node:cc.Node,gameScript:gamblerGame){
        this.cutNode = node;
        // this.cutNode.active = true;
        this.buyScript = this.cutNode.getComponent(gamblerGameObj);
        this.gameScript = gameScript;
        this.resiveCutCount();
        this.updateCutLabel();
    }

    resiveCutCount(){
        let oldday = O1HD.getServices().localStorageSrv.getStorage(this.cutCountDayKey);
        let today = data_control.getCurrDateDayString();
        if(oldday != today){
            this.setCutCount(0);
            O1HD.getServices().localStorageSrv.setStorage(this.cutCountDayKey,today);
        }
    }

    getCutCount(){
        let s = O1HD.getServices().localStorageSrv.getStorage(this.cutCountKey) || "0";
        let sCount:number = Number(s);
        if(isNaN(sCount)){
            sCount = 0;
        }
        return sCount;
    }

    setCutCount(count:number,isPlus:boolean = false){
        let cutCount = this.getCutCount();
        if(isPlus){
            cutCount += count;
        }else{
            cutCount = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.cutCountKey,cutCount);
    }

    onClickReset() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.setCutCount(0);
            this.updateCutLabel();
        },()=>{

        },null,"观看视频获得切木头次数");
    }

    onBtnCut(){
        // 开始切割
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.canCut){
            this.canCut = false;
            this.startCut();
            this.setCutCount(1,true);
            this.updateCutLabel();
        }
    }

    updateCutBtn(){
        this.btnReset.active = false;
        this.startCutBtn.active = false;
        if(this.getCutCount() >= gameConfig.GAMBLER_CUT_COUNT){
            this.btnReset.active = true;
            this.startCutBtn.active = false;
        }else{
            this.btnReset.active = false;
            this.startCutBtn.active = true;
        }
    }

    updateCutLabel(){
        this.labelCount.string = `(${this.getCutCount()}/${gameConfig.GAMBLER_CUT_COUNT})`;
        this.updateCutBtn();
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(this.canCut){
            ModelDialogLayer.show('选择退出物品将消失', null, ()=> {
                this.buyScript.canClick = true;
                this.buyScript.updatePrice();
                this.gameScript.oneNodeBack(this.cutNode);

                this.cutNode?.destroy();
                this.cutNode?.removeFromParent();
                this.scheduleOnce(()=>{
                    this.node.destroy();
                    this.node.removeFromParent();
                })
            }
            , '退  出'
            , '取  消'
            );
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("正在切割木头~");
        }
    }

    // 开始切割
    startCut(){
        // let targetY:number = 120 + (this.cutNode.height / 2)
        // let needTime:number = 3;
        
        // cc.tween(this.cutNode).to(needTime,{y:targetY}).start();
        O1HD.getManagers().soundMgr.playSound("juziju").then(id=>{

        });
        // this.schedule(()=>{
        //     O1HD.getManagers().soundMgr.playVibrate();
        // },0.1,(needTime/0.1)-5);

        this.nodeToolsSpine.node.active = true;
        let trackEntry = this.nodeToolsSpine.setAnimation(0, 'animation', false);

        // let eY = this.buyScript.node.y;
        // let eY = this.completeY - this.nodeToolsSpine.node.height/2;
        // this.nodeToolsSpine.node.setPosition(this.cutTargetX, eY);
        
        this.scheduleOnce(()=>{
            this.cutNode.getComponent(gamblerGameObj).loadEndIcon();
        }, trackEntry.animation.duration);

        this.scheduleOnce(()=>{
            this.gameScript.showClean(this.cutNode);
            this.node.destroy();
            this.node.removeFromParent();
        }, trackEntry.animation.duration + 0.7);
    }
    
}
